import { JourneyData, JourneyTarget } from '@cash-web/shared-journey-data-access-context'

export const getTargetHistory = (history: JourneyData[]) => {
  const targetHistory: Record<JourneyTarget, JourneyData[]> = {
    modal: [],
    fullscreen: [],
    inline: [],
    hidden: [],
    moneybot: [],
  }

  for (const journey of history) {
    const target = (journey.opts?.scope?.['target'] ?? 'modal') as JourneyTarget
    targetHistory[target].push(journey)
  }

  return targetHistory
}
